import { Box } from '#/components/Box/Box';
import { useAppConfig } from '#/config/AppConfigContext';
import { useUser } from '#/contexts/UserEnvironmentContext';
import type { CmsApiPagePost } from '#/modules/cms/api/types/CmsApiPage';
import { CmsAuthorCard } from '#/modules/cms/components/AuthorCard/CmsAuthorCard';
import {
  CmsBodyHolder,
  CmsBodyHolderWidth,
} from '#/modules/cms/components/BodyHolder/CmsBodyHolder';
import { OpenWebWidgetLoadable } from '#/modules/cms/components/Comments/OpenWebWidgetLoadable';
import { CmsReactionsLoadable } from '#/modules/cms/components/Reactions/CmsReactionsLoadable';
import { CmsTagList } from '#/modules/cms/components/TagList/CmsTagList';
import { getCmsApiPageHomePageMeta } from '#/modules/cms/helpers/getCmsApiPageHomePageMeta';

type Props = {
  content: CmsApiPagePost;
};

export function CmsPostPageLayoutBelowBlocks({ content }: Props) {
  const { user } = useUser();
  const { homePageUrl } = getCmsApiPageHomePageMeta({ content });

  const { appConfig } = useAppConfig();
  const openwebEnabled = Boolean(appConfig.openwebSpotId);

  return (
    <>
      {content.tags.length > 0 && (
        <Box mb={32}>
          <CmsBodyHolder $width={CmsBodyHolderWidth.NARROW_LAYOUT}>
            <CmsTagList
              homePageUrl={content.subsite.homePage?.url}
              tags={content.tags}
            />
          </CmsBodyHolder>
        </Box>
      )}

      {content.author && (
        <CmsBodyHolder $width={CmsBodyHolderWidth.NARROW_LAYOUT}>
          <CmsAuthorCard
            author={content.author}
            homePageUrl={homePageUrl}
            postedDate={content.postedDate}
            showDate={content.showDate}
          />
        </CmsBodyHolder>
      )}

      {content.hasReactions || content.hasSocialSharing ? (
        <CmsBodyHolder $width={CmsBodyHolderWidth.NARROW_LAYOUT}>
          <CmsReactionsLoadable content={content} user={user} />
        </CmsBodyHolder>
      ) : null}

      {content.enableComments && openwebEnabled && (
        <CmsBodyHolder $width={CmsBodyHolderWidth.NARROW_LAYOUT}>
          <OpenWebWidgetLoadable
            postId={content.id}
            relativePath={content.url}
            userId={user ? user.id : undefined}
            hasIdealistProfileFeature={
              user ? Boolean(user.hasIdealistProfileFeature) : false
            }
            hasPublicProfile={user ? user.hasPublishedIdealistProfile : false}
          />
        </CmsBodyHolder>
      )}
    </>
  );
}
